import React, { useState } from "react";
import { StatusCode } from "api/protocols";
import { ButtonNew } from "components/buttonNew";
import Card from "components/card/Card";
import DatePickerInput from "components/datePickerInput/DatePickerInput";
import Page from "components/page/Page";

import { useTranslation } from "react-i18next";
import { GetShifts } from "api/rpc/2024-04/facilityAdmin/client/shifts";
import FormLayout from "components/form/FormLayout";
import ButtonGroup from "components/button/ButtonGroup";
import useModal from "hooks/modals/useModal";
import Sheet from "components/sheet/Sheet";

export default function Shifts(props: any) {
  const { t, i18n } = useTranslation();
  const [date, setDate] = useState<Date | null>(null);

  const {
    state: previewModal,
    closeModal: closePreviewModal,
    updateModal: updatePreviewModal,
  } = useModal({ html: "" });

  async function handleShifts(preview: boolean) {
    const ShiftsRes = await GetShifts({ date: date.toDateString() }, true);

    if (ShiftsRes.status !== StatusCode.OK) {
      console.log(ShiftsRes.message);
      return;
    }

    if (preview === true) {
      updatePreviewModal({ isOpen: true, html: ShiftsRes.data });
    } else {
      window.open().document.write(ShiftsRes.data);
    }
  }

  function printShiftSummary() {
    window.open().document.write(previewModal.html);
  }

  return (
    <Page
      title={t("Shifts")}
      subtitle={t("Shifts for employees")}
      narrow
    >
      <Card>
        <Card.Section>
          <p className="mt-2">{t("Pick a Date")}</p>
          <DatePickerInput
            months={2}
            position={"left"}
            startingDate={date}
            setStartingDate={returnDate => setDate(returnDate)}
          />

          <ButtonGroup>
            <ButtonNew className="mt-4" type="primary" onClick={() => handleShifts(false)}>
              {t("Print Shift Summary")}
            </ButtonNew>

            <ButtonNew className="mt-4" type="secondary" onClick={() => handleShifts(true)}>
              {t("Preview Shift Summary")}
            </ButtonNew>
          </ButtonGroup>
        </Card.Section>
      </Card>

      <Sheet
        title={t("Preview Shift Summary")}
        open={previewModal.isOpen}
        size="small"
        closable
        onCancel={closePreviewModal}
        onOk={printShiftSummary}
        okText={t("Print")}
      >
        <div dangerouslySetInnerHTML={{ __html: previewModal.html }}></div>
      </Sheet>
    </Page>
  );
}
